import { render, staticRenderFns } from "./Inventiva.vue?vue&type=template&id=1e69e8f1&"
import script from "./Inventiva.vue?vue&type=script&lang=js&"
export * from "./Inventiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports